import { patchOtherCostFunction } from './patchOtherCostQueryFunction';
import { PatchOtherCostQueryParamsType } from './patchOtherCosts.types';
import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const patchOtherCostQueryOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  PatchOtherCostQueryParamsType
> => ({
  mutationKey: ['PATCH_OTHER_COST_OPTIONS'],
  mutationFn: (params: PatchOtherCostQueryParamsType) =>
    patchOtherCostFunction(params),
});
